import React, { Component } from 'react';
import * as d3 from 'd3';
import { sankeyDiagram } from './sankeyDiagram.js';
import { transformData } from './transformData.js';
import './Sankey.css';
import ReactCursorPosition from 'react-cursor-position';
import Buttons from '../Buttons/Buttons.jsx';

const cityYears = {
    'vancouver':
        [{display: "1991", value: "1991"},
        {display: "2011", value: "2011"}],
    'auckland':
        [{display: "1996", value: "1996"},
        {display: "2013", value: "2013"}],
    'sydney':
        [{display: "2006", value: "2006"},
        {display: "2016", value: "2016"}] 
    };

class Sankey extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            zooming: false,
            mouse: [0, 0]
        };
    }

    componentDidMount() {
        this.createSankey();
    }

    shouldComponentUpdate(newProps, newState) {
        if (cityYears[newProps.city].map(d => d.value).indexOf(newProps.year) == -1) {
            this.updateYear(cityYears[newProps.city][0].value);
            return false;
        }

        d3.select("#sankey-zoom .fg").attr("style", "transform: translate(" + this.state.mouse[0] + "px, " + this.state.mouse[1] + "px) scale(3);");
        d3.select("#sankey-zoom .fg svg .back-layer").attr("style", "transform: translate(-" + this.state.mouse[0] + "px, -" + this.state.mouse[1] + "px);");

        if (newProps.city !== this.props.city || newProps.year !== this.props.year) {
            // uh, this isn't great but it works
            this.setState({data: undefined});
            return false;
        }

        if (newState.data !== this.state.data) {
            return true;
        }

        if (newProps === this.props && newState.zooming === this.state.zooming) {
            return false;
        }



        return true;
    }

    componentDidUpdate() {
        if (!this.state.data) {
            d3.csv('data/sankey/' + this.props.city + '-' + this.props.year + '.csv')
                .then(transformData)
                .then(data => this.setState({ data }));
        } else {
            this.createSankey();
        }
    }

    mouseMoved(e) {
        if (this.state.zooming) {
            this.setState({mouse: [e.position.x + 90, e.position.y - 30]});
        }
    }

    createSankey() {
        if ('data' in this.state) {
            document.getElementById("regional-sankey-fg").innerHTML = '<defs id="fgregional-sankey-defs"></defs>';
            document.getElementById("regional-sankey").innerHTML = '<defs id="regional-sankey-defs"></defs>';

            const {
                data,
                hoveredNode,
            } = this.state;

            d3.select(this.node)
                .attr('width', this.props.width)
                .attr('height', 800)
                .call(sankeyDiagram, {
                    data,
                    width: this.props.width*0.9,
                    height: 800,
                    margin: { left: 225, right: 150, top: 20, bottom: 20 },
                    nodeWidth: 15,
                    nodePadding: 1.5,//5,
                    labelPadding: 3,
                    hover: true,
                    pre: '',
                    city: this.props.city + this.props.year
             });

             d3.select(this.nodeFg)
                .attr('width', this.props.width)
                .attr('height', 800)
                .call(sankeyDiagram, {
                    data,
                    width: this.props.width*0.9,
                    height: 800,
                    margin: { left: 225, right: 150, top: 20, bottom: 20 },
                    nodeWidth: 15,
                    nodePadding: 1.5,//5,
                    labelPadding: 3,
                    hover: true,
                    pre: 'fg',
                    city: this.props.city + this.props.year
             });
        }
    }

    toggleZoom() {
        this.setState({zooming: !this.state.zooming});
    }

    updateYear(year) {
        this.props.update({year});
    }

    render() {
        return (
            <React.Fragment>
            <Buttons 
                values={cityYears[this.props.city]}
                callback={this.updateYear.bind(this)}
                selected={this.props.year}
            />
            <ReactCursorPosition
                onPositionChanged={this.mouseMoved.bind(this)} >
            <div id="sankey-zoom" onClick={this.toggleZoom.bind(this)}>
                <div className={"fg " + (this.state.zooming ? "visible" : "invisible")}>
                    <svg
                        ref={node => this.nodeFg = node}
                        width={500}
                        height={500}
                        id="regional-sankey-fg"
                        className="small">
                        <defs id="fgregional-sankey-defs"></defs>
                    </svg>
                </div>
                <div class="bg">
                    <svg
                        ref={node => this.node = node}
                        width={500}
                        height={500}
                        id="regional-sankey"
                        className="small">
                        <defs id="regional-sankey-defs"></defs>
                    </svg>
                </div>
            </div>
            </ReactCursorPosition>
            </React.Fragment>
        )
    }
}

export default Sankey


// WEBPACK FOOTER //
// ./src/Sankey/Sankey.js